
<owc-table [loading]="spinBool">
  <owc-table-header sticky>
      <owc-table-header-cell sortable [align]="'left'" (sortOrderChange)="OnSort('Type', $event.detail)">{{ 'Type' | transloco }}</owc-table-header-cell>
      <owc-table-header-cell sortable [align]="'left'" (sortOrderChange)="OnSort('LocalId', $event.detail)">ID</owc-table-header-cell>
      <owc-table-header-cell sortable [align]="'left'" (sortOrderChange)="OnSort('Title', $event.detail)">{{ 'Title' | transloco }}</owc-table-header-cell>
      <owc-table-header-cell sortable [align]="'left'" (sortOrderChange)="OnSort('CustomerName', $event.detail)">{{ 'Account Name' | transloco }}</owc-table-header-cell>
      <owc-table-header-cell sortable [align]="'left'" (sortOrderChange)="OnSort('DateDelivered', $event.detail)">{{ 'Date Received' | transloco }}</owc-table-header-cell>
      <owc-table-header-cell sortable [align]="'left'" (sortOrderChange)="OnSort('DeadlineFeedback', $event.detail)">{{ 'Deadline Feedback' | transloco }}</owc-table-header-cell>
      <owc-table-header-cell sortable [align]="'left'" (sortOrderChange)="OnSort('Status', $event.detail)">{{ 'Status' | transloco }}</owc-table-header-cell>
  </owc-table-header>

  <owc-table-body>
    @if(tableData.length > 0){
      @for (item of paginatedData; track $index) {
        <owc-table-row locked (click)="OpenNotificationDetails(item)">

          <owc-table-simple-cell [title]="item.Type">
            <div class="truncate-text">
              {{ item.Type }}
            </div>
          </owc-table-simple-cell>

          <owc-table-simple-cell [title]="item.LocalId">
            <div class="truncate-text">
              {{ item.LocalId }}
            </div>
          </owc-table-simple-cell>

          <owc-table-simple-cell [title]="item.Title">
            <div class="truncate-text">
              {{ item.Title }}
            </div>
          </owc-table-simple-cell>

          <owc-table-simple-cell [title]="item.CustomerName || item.AccountName">
            <div class="truncate-text">
              {{ item.CustomerName || item.AccountName }}
            </div>
          </owc-table-simple-cell>

          <owc-table-simple-cell [title]="item.DateDelivered">
            <div class="truncate-text">
              {{ appUtils.formatDateOnly(item.DateDelivered) }}
            </div>
          </owc-table-simple-cell>

          <owc-table-simple-cell [title]="item.FeedbackDueDate">
            <div class="truncate-text">
              {{ appUtils.formatDateOnly(item.FeedbackDueDate) }}
            </div>
          </owc-table-simple-cell>

          <owc-table-simple-cell style="display: flex; gap: 10px; align-items: anchor-center">
            
            <div style="display: flex; flex-direction: column; gap: 10px;">

              <owc-chip  
              [ngClass]="appUtils.getColor(getDisplayStatus(item))"  
              [title]="getDisplayStatus(item) | transloco">
                <span class="ellipsis">
                  {{ getDisplayStatus(item) | transloco }}
                </span>
              </owc-chip>

              <owc-chip 
              [hidden]="!(accSelected === 'My notifications' && item.Submitter !== item.CustomerContactEmail && item.Submitter !== undefined)"
              title="{{item.Submitter}}"
              style="background-color: #f5f5f2;"
              >
                {{ 'Colleague' | transloco }}
              </owc-chip>

              @if(isToggleableRow(item)){
                <label class="not-read-toggle"
                  (click)="$event.stopPropagation()"
                  [title]="'Mark as Not Read' | transloco"
                  [attr.aria-label]="'Mark as Not Read' | transloco">
                  <input type="checkbox"
                    [checked]="customerservice.isNotRead(item)"
                    (click)="$event.stopPropagation()"
                    (change)="toggleNotRead(item, $event)" />
                  <span class="not-read-toggle__slider"></span>
                  <span class="not-read-toggle__label">{{ 'Mark as Not Read' | transloco }}</span>
                </label>
              }

            </div>
            
            <owc-icon name="chevron_right" family="outlined"></owc-icon>
          </owc-table-simple-cell>

        </owc-table-row>
      }
    }
  </owc-table-body>
</owc-table>

@if (tableData.length < 1) {
  <div class="noDataView">
    @if (spinBool) {
      {{ 'Fetching data...' | transloco }}
    } @else if (searchBool) {
      {{ 'No data available with given search criteria.' | transloco }}
    } @else if (filterBool) {
      {{ 'No data available with given filter criteria.' | transloco }}
    } @else {
      {{ 'No data available.' | transloco }}
    }
  </div>
}

<div class="simple-pagination" *ngIf="totalCount > 0">
  <div class="pagination-left">
    <span class="items-per-page-label">{{ 'Items per page' | transloco }}:</span>
    <select
      class="page-size-dropdown"
      [value]="pageSize"
      (change)="onPageSizeChange($event)">
      <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
    </select>
  </div>

  <div class="pagination-center">
    <span class="pagination-info">{{ startIndex }} - {{ endIndex }} {{ 'of' | transloco }} {{ totalCount }}</span>
  </div>

  <div class="pagination-right">
    <button class="nav-button" [disabled]="currentPage === 0" (click)="goToFirstPage()" title="First page">&#8810;</button>
    <button class="nav-button" [disabled]="currentPage === 0" (click)="goToPreviousPage()" title="Previous page">&#8249;</button>
    <button class="nav-button" [disabled]="currentPage >= totalPages - 1" (click)="goToNextPage()" title="Next page">&#8250;</button>
    <button class="nav-button" [disabled]="currentPage >= totalPages - 1" (click)="goToLastPage()" title="Last page">&#8811;</button>
  </div>
</div>

